import { mediaqueries } from "../../styles/mediaqueries";
import { StoryblokAsset } from "../storyblok/types/fieldtypes/storyblokAsset";

type Key = keyof typeof mediaqueries;
type ViewWidths = `${number}${"vw" | "px" | "em" | "rem"}`;
type Queries = Record<Key, ViewWidths>;
export type ImageSizes = string;

export const imageSizes = (
  maxSize: ViewWidths,
  queries?: Partial<Queries>
): ImageSizes =>
  [
    ...Object.entries(queries ?? {}).map(
      ([key, width]) => `${key ? mediaqueries[key] : ""} ${width}`
    ),
    `${maxSize}`,
  ].join(", ");

export const isValidImageData = (
  image: StoryblokAsset | undefined | null
): boolean => {
  if (!image) return false;

  return (
    "filename" in image &&
    "fieldtype" in image &&
    !!image.filename &&
    typeof image.filename === "string"
  );
};

export const isStoryblokAsset = (image: unknown): image is StoryblokAsset => {
  return !!(
    image &&
    typeof image === "object" &&
    "filename" in image &&
    "fieldtype" in image &&
    (image as StoryblokAsset).filename &&
    typeof (image as StoryblokAsset).filename === "string"
  );
};
